import {createContext} from 'react'
import axios from '../../../../../api/axios'

export const actions = {
    getLogs:function(orderId){
        try {
            return axios.get(`/api/v1/admin/orders/${orderId}/logs`)    
        } catch (error) {
            throw error;
        }
    },
    getOrder:function(orderId){
        try {
            return axios.get(`/api/v1/admin/order/${orderId}`)
        } catch (error) {
            throw error;
        }
    },
    getCommission:function(orderId){
        try {
            return axios.get(`/api/v1/admin/orders/tendering/${orderId}/fullCommissionDetails`)
        } catch (error) {
            throw error;
        }
    }
};
export const store = createContext(null);
export const initialState = {
    order:null,
    logs:null,
    chats:null,
    commissions:null,
    bidders:null
}

export function reducer(state,action){
    const {payload,type} = action;
    switch (type) {
        case 'ORDER':
            return {...state,order:payload};
        case 'LOGS':
            return {...state,logs:payload};
        case 'COMMISSIONS':
            return {...state,commissions:payload};
        case 'BIDDERS':
            return {...state,bidders:payload};
        default:
            return {...state};
    }
}